import React, { useState } from "react";
import { ENGINE_COMPONENT_TYPES } from "../../constants";
import Accordion from "./Accordion";
import AmbientLight from "./AmbientLight";
import EnvironmentLight from "./EnvironmentLight";

const defaultAmbient = {
  intensity: 0,
  color: null,
};

const defaultExposure = {
  name: "",
  exposure: 0,
};
const LightSettingsTab = ({ componentConfig, templateConfig }) => {
  const [render, setRender] = useState(0);

  const panelList = componentConfig?.components.map((component) => {
    let renderComp = null;
    switch (component.type) {
      case ENGINE_COMPONENT_TYPES.AMBIENT_LIGHT: {
        const currentConfig = component.getCurrentConfig();
        const ambientConfig = templateConfig.getConfigByPlatform(
          currentConfig,
          defaultAmbient
        );
        renderComp = (
          <AmbientLight
            currentConfig={ambientConfig}
            applyAmbientLight={component.applyAmbientLight}
            updateConfig={(config) => {
              const updatedConfig = templateConfig.updatePlatformConfig(
                currentConfig,
                config
              );
              setRender(render + 1);
              return component.updateConfig(updatedConfig);
            }}
          />
        );
        break;
      }

      case ENGINE_COMPONENT_TYPES.ENVIRONMENT_LIGHT: {
        const currentConfig = component.getCurrentConfig();
        const envLightConfig = templateConfig.getConfigByPlatform(
          currentConfig,
          defaultExposure
        );
        renderComp = (
          <EnvironmentLight
            updateEnvironmentLight={component.updateEnvironmentLight}
            applyEnvironmentIntensity={component.applyEnvironmentIntensity}
            currentConfig={envLightConfig}
            updateConfig={(config) => {
              console.log("environment light update", currentConfig, config);
              setRender(render + 1);
              const updatedConfig = templateConfig.updatePlatformConfig(
                currentConfig,
                config
              );
              return component.updateConfig(updatedConfig);
            }}
            getHDRIOptions={component.getHDRIOptions}
          />
        );
        break;
      }
      default:
        renderComp = null;
    }
    return {
      header: component.title,
      headerClass: "light-accordion-header",
      component: renderComp,
    };
  });

  return (
    <div className="lightSettingContainer">
      <Accordion className="light-accordion" panelList={panelList} />
    </div>
  );
};

export default LightSettingsTab;
